import { createContext, useContext } from 'react';
import { formatBs, formatBsNice, formatBsMonth } from '../utils/calendar';

const CalendarContext = createContext(null);

export function CalendarProvider({ children }) {
  // ── Display calendar is now unconditionally Bikram Sambat (BS) ──────────────────────
  // The per-user / per-club calendar toggle was RETIRED (Step 2). Full dates render via
  // <DualDate> (BS primary + muted AD); the helpers below keep working for the ~30 month-label
  // and nice-date consumers, always in BS. AD stays available as a muted secondary reference
  // (and as an input convenience inside DualDatePicker), never as a display preference.
  //
  // NOTE: Club.defaultCalendar and User.calendarPreference are FROZEN dead fields — they are no
  // longer read here. Finance month grouping and the overdue/recurring crons still read the
  // club's stored defaultCalendar DIRECTLY (see financeController / cashFlowController /
  // recurringExpenseService / markOverdueFees), so those numbers do not move. That finance/cron
  // math is scheduled to move to BS in a separate change.
  const currentCalendar = 'bs';

  // Retained as a harmless no-op so any stray caller doesn't crash — nothing sets the calendar now.
  const setCalendar = () => {};

  const formatDate = (date) => {
    if (!date) return '—';
    try { return formatBs(date); } catch { return '—'; }
  };

  const formatDateNice = (date) => {
    if (!date) return '—';
    try { return formatBsNice(date); } catch { return '—'; }
  };

  // yearMonth: "YYYY-MM" string
  const formatMonth = (yearMonth) => {
    if (!yearMonth) return '—';
    try { return formatBsMonth(yearMonth); } catch { return '—'; }
  };

  return (
    <CalendarContext.Provider value={{ currentCalendar, setCalendar, formatDate, formatDateNice, formatMonth }}>
      {children}
    </CalendarContext.Provider>
  );
}

export function useCalendar() {
  return useContext(CalendarContext);
}
